export default __webpack_public_path__ + "images/Fondue.74418e.jpg";